import { useState } from "react";

import Button from "../../../common/Button";
import OutsideClickComponent from "../../../fragments/OutsideClickComponent";

import classes from './LienHistory.module.css'
import LienHistoryModal from "./lienHistory/LienHistoryModal";
import { detailsActions } from "../../../../store/details";
import { useDispatch } from "react-redux";
import { historyActions } from "../../../../store/history";

const MockHistoryData = [
    {
        date: '2/18/2024',
        text: 'AICA Driver Notice of Lien created by AICAORTHO on Day 18 of Treatment.'
    },
    {
        date: '2/21/2024',
        text: 'AICA Liability Carrier (State Farm) Notice of Lien created by AICAORTHO on Day 18 of Treatment.'
    },
    {
        date: '2/23/2024',
        text: "AICA Lien created and filed in Patient's County of Record (FULTON) by AICAOTHO on Day 33 of Treatment."
    },
    {
        date: '2/28/2024',
        text: "AICA Lien created and filed in Primary Clinic's County of Record (COBB) by AICAOTHO on Day 33 of Treatment."
    },
]

export default function LienHistory({ inWorkQ }) {
    const dispatch = useDispatch()
    const [showModal, setShowModal] = useState(false)

    if (inWorkQ) {
        return null
    }

    function openModalHandler() {
        setShowModal(prevState => prevState = !prevState)
    }

    function closeModalHandler() {
        setShowModal(false)
    }
    
    const openTabHandler = () => {
        dispatch(detailsActions.setActiveTab(27))
        dispatch(historyActions.setCurrentPage(1))
        dispatch(historyActions.setFiltersMultiple({
            // model_type: 'App\\Models\\CaseLien'
            model_type: {
                value: 'App\\Models\\CaseLien',
                item: {
                    label: 'Case Lien',
                    value: 'App\\Models\\CaseLien',
                }
            }
        }))
        dispatch(historyActions.setRefreshApi())
        // if (noteTypeId) {
        //     dispatch(detailsActions.setNotesType(noteTypeId))
        // }
    }

    return <div className={classes.container}>
        <Button click={openModalHandler} isDisabled={showModal} btnStyle={'btn_small'}><i className='ti ti-history'></i>View history</Button>
        {showModal && <OutsideClickComponent task={closeModalHandler}>
            <div className={classes.items_container}>
                <div className={classes.modal_header}>
                    <div className="flex-container flex-container-space-betwen">
                        <h3>History</h3>
                        <Button click={openTabHandler} btnStyle={'btn_simple'}>View in tab <i className='ti ti-arrow-right'></i></Button>
                    </div>
                </div>
                <div className={classes.modal_body}>
                    <LienHistoryModal />
                    {/* {MockHistoryData.map(item => (
                        <div key={item.date} className={classes.item}>
                            <div className={classes.date}>{item.date}</div>
                            <div className={classes.text}>{item.text}</div>
                        </div>
                    ))}  */}
                </div>    
            </div>                   
        </OutsideClickComponent>}
    </div>
}